import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';

import { Info } from './Info/Info';

import './Results.css';


export const Results = () => {
  const policies = useSelector((state) => state.formUserInteractionReducer.requestedPolicies);

  useEffect(() => {
    scroll.scrollToBottom();
  });

  return (
    <div className="contain text-center result show-results">
      <div>
        <h2>Resultaat</h2>
        <table className="calculate-premius">
          <thead>
            <tr>
              <td className="insurer">Verzekeraar</td>
              <td className="monthly-premium">Premie per maand</td>
              <td className="yearly-premium">Totaal looptijd</td>
            </tr>
          </thead>
          <tbody>
            {policies.map((item) => (
              <tr key={item.policyTerms}>
                <td className="insurer">{item.policyTerms}</td>
                <td className="monthly-premium">€&nbsp;{item.premiumProgression.amount}</td>
                <td className="yearly-premium">€&nbsp;{item.premiumProgression.fullPeriodCost}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Info/>
      </div>
    </div>
  );
};
